import useSearchParams from './useSearchParams'

export const useBranchOfficeFilter = filterValues => {
  const searchParams = useSearchParams()
  const branchOfficeId = searchParams.get('branch_office_id')
  return filterValues.includes(branchOfficeId)
}
